module.exports = __webpack_public_path__ + "img/Trophy Cup Table25.1dc92220.jpg";